export abstract class CircleConstants {
  // Maximum video length in seconds of a message.
  static maxMessageLengthInSeconds = 20;

  // Maximum video length in seconds of a challenge.
  static maxChallengeLengthInSeconds = 60;
}
